import SceneView from "../../../vendor_core/core/src/views/SceneView";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { TimelineMax, TweenMax } from 'gsap';
import Layer from '../../../vendor_core/core/src/utils/Layer';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import TextField from '../../../vendor_core/core/src/views/components/TextField';
import BBModel from '../model/BBModel';
import App from '../../../vendor_core/core/src/App';
import Layout from '../../../vendor_core/core/src/utils/Layout';
import Utils from '../../../vendor_core/core/src/utils/Utils';

class BBMultiplierController {
    protected multiplierScene: SceneView;
    protected layer: Layer;
    protected onCompleteTL: Function[] = [];
    protected timeline: TimelineMax;
    protected colors = ["red", "blue", "purple", "orange", "green", "yellow"];
    protected colorMap = {
        red: 6,
        yellow: 5,
        green: 4,
        orange: 2,
        purple: 3,
        blue: 1,
    }

    public setUp = () => {
        this.layer = ViewManager.getLayer(DefaultLayers.PaylineCelebration);
        this.multiplierScene = ViewManager.getLayer(
            "MultiplierContent"
        ).getCurrentScene();
        this.resetMultipliers();
        this.multiplierScene.sceneSprites.forEach((value, key) => {
            if (key.includes("_bg")) {
                value.alpha = 0;
            }

        })
    }



    public playMultiplierAnim = () => {
        let colorsToFloat = this.updateMultiplier(BBModel.getCurrentSpinProperty("multiplierAfter"))

        if (this.timeline) {
            this.timeline.progress(1);
            this.timeline.kill();
            this.timeline = null;
        }

        this.onCompleteTL.push(() => {
            if (this.multiplierScene.getSubView("multiFloat") != undefined) {
                this.multiplierScene.removeSubView("multiFloat")
            };
        })

        this.timeline = new TimelineMax({
            paused: true,
            onComplete: () => {
                this.onCompleteTL.forEach(fn => fn());
                this.onCompleteTL = [];
            },
        });

        colorsToFloat.forEach(color => {
            this.setMultiplier(color);
        });

        this.timeline.play()

    }

    private setMultiplier = (color: string) => {
        const scene = this.layer.getOrphanedScene("win");
            let multiFloat = scene.sceneTextFields.get(
                "multi"
            ) as TextField
            let multi = this.multiplierScene.sceneTextFields.get(
                color + "Multiplier"
            ) as TextField
            let multiplierAnims = ViewManager.getLayer("MultiplierContent").getCurrentScene().spineAnimations;
            let multiplierUIanim = multiplierAnims.get(`multiplier_ui_${this.colorMap[color]}`);
            // let shineValueAnim = multiplierAnims.get(`multiplier_${this.colorMap[color]}`);
            let shineSprite = this.multiplierScene.sceneSprites.get(`${color}_bg`);
            let multiplierTextArr = multi.text.split("")
            let multiplierNum = parseInt(multiplierTextArr[1]) - 1
            multiFloat.text = "x" + multiplierNum.toString();

            // multiFloat.style.fontSize = Number(multi.style.fontSize) * 2;
            // let newStyle = Utils.deepClone(multiFloat.style)
            // newStyle.fill = color;
            // multiFloat.updateStyle(multi.style);
            multiFloat.style.fontSize = +multi.style.fontSize * 1.1;
            multiFloat.style.fill = multi.style.fill;
            // console.log(multiFloat.style.fontSize);
            // console.log(multi.style.fontSize);

            // if (Layout.isLandscape()) {
            //     // multiFloat.x = multi.getBounds().x - (multi.getBounds().width / 2 * Layout.globalScale);
            // } else {
            //     // multiFloat.x = multi.getBounds().x - (multi.getBounds().width * Layout.globalScale);
            // }
            // multiFloat.x = multi.getBounds().x - multi.getBounds().width / 2;
            multiFloat.x = multi.getBounds().x;
            multiFloat.y = multi.getBounds().y;
            multiFloat.width = multi.getBounds().width;
            multiFloat.height = multi.getBounds().height;

            this.multiplierScene.addSubView(multiFloat, "multiFloat");
            let time = (4 * Layout.globalScale);
            let differenceY = (300 * Layout.globalScale);
            this.timeline.add(TweenMax.to(multiFloat, time, {
                y: multiFloat.y - differenceY,
                alpha: 0,
            }), 0);

            // let startY = shineValueAnim.parent.y;
            let startY = shineSprite.y;
            this.onCompleteTL.push(() => {
                // shineValueAnim.parent.y = startY
                shineSprite.y = startY
            })
            shineSprite.alpha = 1
            // shineValueAnim.parent.alpha = 1;
            // this.timeline.add(TweenMax.to(shineValueAnim.parent, time, {
            //     y: shineValueAnim.parent.y - differenceY,
            //     alpha: 0,
            // }), 0);
            this.timeline.add(TweenMax.to(shineSprite, time, {
                y: shineSprite.y - differenceY,
                alpha: 0,
            }), 0);

            multiplierUIanim.playAndHide("multiplier_ui_change");
            // shineValueAnim.play("intro_with_part");
            // shineValueAnim.showStatic()
            // TweenMax.delayedCall(shineValueAnim.animConfig.stopTimeOnStatic, () => shineValueAnim.showStatic());
    }

    public updateMultiplier = (multipliersAfter: any[]): string[] => {
        if (multipliersAfter === undefined || multipliersAfter.length === 0) {
            return []
        }

        this.colors.forEach((color, index) => {
            if (this.multiplierScene.sceneTextFields.get(color + "Multiplier")) {
                this.multiplierScene.sceneTextFields.get(color + "Multiplier").text = "x" + (multipliersAfter[index]);
            }
        });
        let colorsToFloat = [];
        let multipliersBefore = BBModel.getCurrentSpinProperty("multiplierBefore")
        for (let i = 0; i < multipliersBefore.length; i++) {
            if (multipliersAfter[i] != multipliersBefore[i]) {
                colorsToFloat.push(this.colors[i])
            }
        }

        return colorsToFloat;
    };


    public resetMultipliers = () => {
        // let totalMultiplier = multiplierScene.sceneTextFields.get("ui_multiplier");
        for (let i = 1; i < 7; i++) {
            let balloonColor = App.config.symbolAssetsMap[i].name;
            let textField = balloonColor + "Multiplier";
            this.multiplierScene.sceneTextFields.get(textField).text = "x1";
        }
    };
}

export default new BBMultiplierController()
